<template>
  <section class="page-tips">
    <div class="page-tip-label">报名方法及注意事项：</div>
    <div class="page-tip-wrap">
      <div class="page-tip">1、{{ tip }}，请联系:<span class="highlight">0571-56551766</span>。</div>
      <div class="page-tip">2、正确输入姓名、联系电话、证书编号等信息，点击{{ type === 1 ? '报名': '申请' }}。</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageTips',
  inject: {
    tip: { default: '' },
    type: { default: 1 }
  }
}
</script>
<style lang="stylus" scoped src="./page-tips.styl"></style>
